<template>
  <div class="fixed bottom-6 right-6 z-10 w-80 rounded-md border border-secondary-light bg-secondary-darker shadow-xl" data-testid="onboarding-checklist">
    <button
      type="button"
      class="flex w-full items-center justify-between px-4 py-3"
      @click="collapsed = !collapsed"
    >
      <span class="font-bold text-common-white">Erste Schritte</span>
      <span class="flex items-center gap-2 text-sm text-secondary-lighter">
        {{ doneCount }}/{{ checklist.length }}
        <BIconChevronDown class="h-4 w-4 transition-transform" :class="collapsed ? 'rotate-180' : ''" />
      </span>
    </button>
    <div class="mx-4 h-1 rounded-full bg-secondary">
      <div class="h-1 rounded-full bg-lilac transition-all" :style="{ width: `${(doneCount / checklist.length) * 100}%` }" />
    </div>

    <ul v-if="!collapsed" role="list" class="px-4 py-3 space-y-3">
      <li v-for="step in checklist" :key="step.id" class="flex items-start gap-3" :data-testid="`onboarding-step-${step.id}`">
        <span
          class="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ring-1"
          :class="step.done ? 'bg-lilac ring-lilac' : 'ring-secondary-light'"
        >
          <BIconCheck v-if="step.done" class="h-4 w-4 text-common-white" />
        </span>
        <div class="min-w-0 flex-1">
          <p class="text-sm" :class="step.done ? 'text-secondary-light line-through' : 'text-common-white'">
            {{ step.title }}
          </p>
          <p v-if="!step.done" class="text-xs text-secondary-light">
            {{ step.blocked ? 'Legen Sie zuerst eine Monitoring-Domäne an.' : step.description }}
          </p>
        </div>
        <button
          v-if="!step.done && !step.blocked"
          type="button"
          class="text-xs text-lilac-light hover:underline whitespace-nowrap"
          @click="startStepTour(step.id)"
        >
          Zeigen
        </button>
      </li>
    </ul>

    <div v-if="!collapsed" class="flex justify-between border-t border-secondary px-4 py-2">
      <button type="button" class="text-xs text-secondary-light hover:text-secondary-lighter" @click="refreshStatus">
        Aktualisieren
      </button>
      <button
        v-if="doneCount === checklist.length"
        type="button"
        class="text-xs text-lilac-light hover:underline"
        @click="complete"
      >
        Fertig, Onboarding beenden
      </button>
      <button
        v-else
        type="button"
        class="text-xs text-secondary-light hover:text-secondary-lighter"
        title="Wird nach der nächsten Anmeldung wieder angezeigt. Dauerhaft ausblenden in den Account-Einstellungen."
        @click="hideForSession"
      >
        Ausblenden
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BIconCheck, BIconChevronDown } from 'bootstrap-icons-vue'

const { steps, startStepTour, complete, hideForSession, refreshStatus } = useOnboarding()

const collapsed = ref(false)
const checklist = computed(() => steps.value)
const doneCount = computed(() => checklist.value.filter(s => s.done).length)
</script>
